import { Box, Image, Text } from '@chakra-ui/react';
import { StorageManager } from '@storage/index';
import { ProfileUserProps } from '@components/Header/interface';
import { useGet } from '@hooks/useGet';
import { Module } from '@models/Module';
import { useMemo } from 'react';

export const ProfileUser = ({ user, moduleStorage, courseModules }: ProfileUserProps) => {
	const storage = useMemo(() => new StorageManager('session'), []);
	const module = storage.getItem<Module>('selectedModule');

	const { data: picture, isLoading } = useGet<string>({
		queryKey: ['HomeStudentProblem', module?.CODMODULO, user?.CODCOLIGADA, user?.RA],
		request: {
			endpoint: '/professor/profile-picture',
			params: {
				CODCOLIGADA: user?.CODCOLIGADA,
				RA_OU_PROF: user?.RA,
			},
		},
	});

	return (
		<Box display="flex" alignItems="center">
			<Box display="flex" alignItems="flex-end" mr="13px" flexDirection="column">
				<Text fontSize="12px" fontWeight="bold" color="neutral.200" isTruncated maxW="150px">
					{user?.NOME}
				</Text>

				<Text fontSize="11px" fontWeight="light" color="primary.200" m="0">
					RA {user?.RA}
				</Text>

				{moduleStorage?.CODPERLET ? (
					<Text fontSize="11px" fontWeight="light" color="primary.200" m="0px">
						{moduleStorage?.CODPERLET} - Medicina
					</Text>
				) : (
					<>
						{courseModules && (
							<Text fontSize="11px" fontWeight="light" color="primary.200" m="0px">
								{courseModules[0].CODPERLET} - Medicina
							</Text>
						)}
					</>
				)}
			</Box>

			<Image
				style={{ borderRadius: '50%', objectFit: 'cover', outline: '2px solid #feb511' }}
				src={isLoading || !picture ? '/images/people.svg' : 'data:image/jpg;base64,' + picture}
				alt="logo-afya"
				h="44px"
				w="44px"
			/>
		</Box>
	);
};
